import { useMemo, useState } from 'react';
import { generatePath, NavLink } from 'react-router-dom';

import { ROUTE_PATHS } from 'shared/consts/routes';
import { useTypedSelector } from 'store';
import { RadioBox } from 'ui/RadioBox/RadioBox';

import { DSCoverAddPairModal } from './DSCoverAddPairModal';

export function isDsCoverProject(notes?: string) {
  return (notes || '').includes('ds-cover');
}

export function DSCoverProjects() {
  const projects = useTypedSelector(store => store.projects.projects);
  const dsCoverProjects = useMemo(
    () => (projects ?? []).filter(project => isDsCoverProject(project.notes)),
    [projects],
  );
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [addPairProjectId, setAddPairProjectId] = useState<number | null>(null);

  return (
    <div data-testid="ds-cover-projects">
      {dsCoverProjects.map(project => {
        const opened = selectedId === project.id;
        return (
          <div key={project.id} className="mm-sidebar__projects__project">
            <button
              type="button"
              className="mm-sidebar__menu__item"
              onClick={() => setSelectedId(opened ? null : project.id)}
            >
              {project.name}
            </button>
            {opened && (
              <div>
                {(project.cexPairs ?? []).map(pair => (
                  <NavLink
                    key={pair.id}
                    to={generatePath(ROUTE_PATHS.cexPair, {
                      projectId: String(project.id),
                      pairId: String(pair.id),
                    })}
                  >
                    <RadioBox checked={false} text={`${pair.cex} · ${pair.symbol}`} />
                  </NavLink>
                ))}
                <button
                  type="button"
                  data-testid="ds-cover-add-pair"
                  onClick={() => setAddPairProjectId(project.id)}
                >
                  Add pair
                </button>
              </div>
            )}
          </div>
        );
      })}
      {addPairProjectId !== null && (
        <DSCoverAddPairModal
          projectId={addPairProjectId}
          onClose={() => setAddPairProjectId(null)}
        />
      )}
    </div>
  );
}
